export type Plan = {
  id: string
  name: string
  tagline: string
  description: string
  features: string[]
  isPopular?: boolean
  stripeProductId: string | null
}

export const plans: Plan[] = [
  {
    id: 'free',
    name: 'Free',
    tagline: 'A simple way to explore and build your first app.',
    description: '',
    features: [
      '20 AI app edits /month',
      '40 uses of your app /month',
      'All apps are public',
      'Watermark: "Made with Sprites" on your public app links',
      '1 active app limit',
    ],
    stripeProductId:
      process.env.NODE_ENV === 'production' ? 'prod_SEu27wbYlIyAKP' : 'prod_Rtvhh5o37Hrrqr',
  },
  {
    id: 'pro',
    name: 'Pro',
    tagline: 'More power, privacy, and creative freedom',
    description: 'Everything in Free, plus:',
    features: [
      '150 AI edits /month',
      '500 app executions /month',
      'Create private apps',
      'No watermark on your apps',
      'Up to 10 active apps',
      'Access to premium app templates',
    ],
    stripeProductId:
      process.env.NODE_ENV === 'production' ? 'prod_SEu2cVtMBGFJLg' : 'prod_RtBz3En6vgrjyY',
  },
  {
    id: 'launch',
    name: 'Launch',
    tagline: 'Unlimited scale and faster performance',
    description: 'Everything in Pro, plus:',
    features: [
      'Unlimited AI edits',
      'Unlimited app executions',
      'Unlimited active apps',
      'Eligible for the Creator Monetization Pool',
    ],
    stripeProductId:
      process.env.NODE_ENV === 'production' ? 'prod_SEu2TmkYXPtINW' : 'prod_RtC0kvXgUs79kN',
  },
  {
    id: 'business',
    name: 'Business',
    tagline: 'Custom support and enterprise-ready tools',
    description: 'Everything in Launch, plus:',
    features: [
      'Dedicated support from our engineering team',
      'Help with deployment, integrations, and infrastructure',
      'Custom analytics, branding, and compliance options',
      'Tailored onboarding and setup for you use case',
    ],
    stripeProductId: null,
  },
]
